import React from "react";
import "./MissionSection.css";

const features = [
  "Advanced AI, Robotics & IoT Lab Integration",
  "Industry-aligned Infrastructure Guidance with Domain Expert",
  "Hands-on Innovation Spaces Designed for Practical Learning",
  "End-to-End Implementation, Training & Long-term Technical Support",
  "Support for Competitions, Research Activities & Student Innovation Programs",
];

export default function MissionSection() {
  return (
    <section className="mission-section">
      <div className="mission-container">

        {/* LEFT VIDEO */}
        <div className="mission-image">
          <video
            className="mission-media"
            src="/assets/videos/videoanimation.mp4"
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="mission-overlay"></div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="mission-card">

          <div className="mission-label">
            <span className="line"></span> OUR MISSION
          </div>

          <h2>
            Building <span>Centre of Excellence</span> <br />
            &amp; <span>Innovation Lab</span>
          </h2>

          <p>
            We are committed to empowering schools, colleges, and institutions
            with future-ready Centre of Excellence (CoE) and Innovation Lab
            environments focused on AI, Robotics, IoT, Embedded Systems, Drone
            Technology, and Industry 5.0 solutions.
          </p>

          <p>
            Our mission is to create hands-on innovation ecosystems where students
            can transform ideas into real-world applications, gain industry-oriented
            technical skills, and work on live projects that inspire creativity,
            research, and entrepreneurship.
          </p>

          <ul>
            {features.map((item) => (
              <li key={item}>
                <span className="tick-circle">&#10004;</span> {item}
              </li>
            ))}
          </ul>

        </div>

      </div>
    </section>
  );
}